import React from 'react';
import { steps } from '../../constants';

export function StepsCard() {
  return (
    <div className="steps">
      <div className="panel-header">
        <div>
          <p className="eyebrow">Build plan</p>
          <h2>IDE checklist</h2>
        </div>
        <button className="micro ghost-btn">Docs</button>
      </div>
      <div className="step-list">
        {steps.map((step) => (
          <div key={step.title} className={`step ${step.status}`}>
            <div className="step-icon" aria-hidden />
            <div>
              <p className="step-title">{step.title}</p>
              <p className="muted">{step.detail}</p>
            </div>
            <span className="pill small">{step.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
